import { createSlice } from "@reduxjs/toolkit";
import { CnamLookupOutputDTO } from "../model/output/cnamLookupRequestOutputDTO";
import * as CnamReducers from "../reducer/cnamReducers";

const cnamSlice = createSlice({
  name: "cnam",
  initialState: initCnamState(),
  reducers: {
    ...CnamReducers,
  },
});

export interface CnamUpdateResponse {
  showModal: boolean;
  requestId: string;
  output: { tn: string; desiredCName: string }[];
  failedOutput: { tn: string; desiredCName: string; reason: string }[];
}

export interface CnamState {
  isLoading: boolean;
  cnamLookup: CnamLookupOutputDTO[];
  cnamUpdateResponse: CnamUpdateResponse;
}

function initCnamState(): CnamState {
  return {
    isLoading: false,
    cnamLookup: [],
    cnamUpdateResponse: {
      requestId: "",
      showModal: false,
      output: [],
      failedOutput: [],
    },
  };
}
const cnamActions = cnamSlice.actions;

export { cnamActions, cnamSlice };
